import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Team } from '../../_shared/models/team.model';
import { usaStates } from 'typed-usa-states/dist/states';

@Component({
  standalone: false,
  selector: 'app-team-item',
  templateUrl: './team-item.component.html',
  styleUrls: ['./team-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamItemComponent {
  @Input() team: Team;
  @Input() showDetails = true;
  @Input() itemLine;
  @Input() showRemoveTeam = false;
  @Output() removeTeam = new EventEmitter<boolean>();

  states = usaStates;

  constructor() {}

  triggerRemoveTeam() {
    this.removeTeam.emit(true);
  }
}
